import { render, staticRenderFns } from "./educationResultTab.vue?vue&type=template&id=98338d0c"
import script from "./educationResultTab.vue?vue&type=script&lang=js"
export * from "./educationResultTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98338d0c')) {
      api.createRecord('98338d0c', component.options)
    } else {
      api.reload('98338d0c', component.options)
    }
    module.hot.accept("./educationResultTab.vue?vue&type=template&id=98338d0c", function () {
      api.rerender('98338d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationResultTab.vue"
export default component.exports